export const mutations = {
  setSelectedVehicles(state, vehicles) {
    state.selectedVehicles = vehicles;
  },
  setLaunchedVehicles(state, launchedVehicles) {
    state.launchedVehicles = launchedVehicles;
  },
  togglePerformanceWidget(state) {
    state.performanceWidgetExpanded = !state.performanceWidgetExpanded;
  },
};

export const actions = {

  setSelectedVehiclesData({ commit }, vehicles) {
    commit('setSelectedVehicles', vehicles);
  },
  setLaunchedVehiclesData({ commit }, launchedVehicles) {
    commit('setLaunchedVehicles', launchedVehicles);
  },
  togglePerformanceWidget({ commit }) {
    commit('togglePerformanceWidget');
  },
};

export const getters = {
  selectedVehicles: (state) => state.selectedVehicles,
  launchedVehicles: (state) => state.launchedVehicles,
  performanceWidgetExpanded: (state) => state.performanceWidgetExpanded,
};

export const state = {
  selectedVehicles: [],
  launchedVehicles: {},
  performanceWidgetExpanded: true,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
